import _Map from "@babel/runtime-corejs3/core-js/map";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DraggableVirtualList from "vue-draggable-virtual-scroll-list";
import VirtualScrollerItem from "./virtual-scroller-item";
import { allowPropagationScroll } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
const profileSourceCache = new _Map();
const getProfileSource = id => {
  if (!profileSourceCache.has(id)) {
    profileSourceCache.set(id, {
      id
    });
  }
  return profileSourceCache.get(id);
};
export default defineComponent({
  name: "ClientProfileList",
  components: {
    DraggableVirtualList
  },
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      aLot: false,
      VirtualScrollerItem
    };
  },
  computed: {
    profileSources: {
      get() {
        var _context;
        return _mapInstanceProperty(_context = this.value).call(_context, getProfileSource);
      },
      set(sources) {
        this.$emit("input", _mapInstanceProperty(sources).call(sources, ({
          id
        }) => id));
      }
    },
    sortableEmpty() {
      return this.value.length === 0;
    }
  },
  methods: {
    handleDraggableStart(event) {
      this.$emit("start", event);
    },
    handleDraggableEnd(event) {
      this.$emit("end", event);
    },
    handleWheel(event) {
      allowPropagationScroll(event, this.$refs.virtualList.$el);
    }
  }
});